import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { MemberService } from './../../rest/api/member.service';
import { HelperService } from './../../services/helper.service';
import { AuthService } from './../../services/auth.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  accessToken: any;
  userData: any;
  // loader = true;
  constructor(
    public router: Router,
    public fb: FormBuilder,
    public memberService: MemberService,
    public helperService: HelperService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public title: Title
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.getProfile();
  }

  getProfile() {
    this.memberService.getProfile(this.accessToken).subscribe((response: any) => {
      this.userData = response && response.data ? response.data : undefined;
      // this.loader = false;
      this.authService.setMembersData(response && response.data ? response.data : undefined);
    }, err => {
      this.authService.logout();
      window.location.href = '/login';
    });
  }

}
